import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IonCard, IonCardContent, IonCol, IonGrid, IonRow, IonSkeletonText } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-skeleton-card-table',
  templateUrl: './skeleton-card-table.component.html',
  styleUrls: ['./skeleton-card-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonGrid, IonSkeletonText, IonCol, IonCardContent, IonRow, IonCard],
})
export class SkeletonCardTableComponent {
  // constructor() {}
}
